import { getData } from "./apiUtils";
import * as CONFIG from '../utils/config';

export function isSuperUser() {
    return getData(CONFIG.IS_SUPER_USER_URL(),
        (response) => {
            if (!response.ok) {
                return false;
            }

            return response.text().toLowerCase() === 'true';
        },
        () => false
    );
}
